import { ObjectValues } from "@/src/shared/types/objectValues";

export const DS_COLOR_PALETTE = {
  Color01: "01",
  Color02: "02",
  Color03: "03",
  Color04: "04",
  Color05: "05",
  Color06: "06",
  Color07: "07",
  Color08: "08",
  Color09: "09",
  Color10: "10",
  Color11: "11",
  Color12: "12",
  Color13: "13",
  Color14: "14",
} as const;

export type DSColorPalette = ObjectValues<typeof DS_COLOR_PALETTE>;
